// German words, without umlauts
// used for user generation for Hefte Teacher Feature
export const HEFTE_WORDLIST = [
  'Hund',
  'Katze',
  'Tisch',
  'Stuhl',
  'Haus',
  'Buch',
  'Auto',
  'Ball',
  'Maus',
  'Sonne',
  'Mann',
  'Frau',
  'Kind',
  'Hut',
  'Hand',
  'Bein',
  'Feld',
  'Wald',
  'See',
  'Berg',
  'Fisch',
  'Stern',
  'Mond',
  'Baum',
  'Blatt',
  'Sand',
  'Stein',
  'Wind',
  'Regen',
  'Schnee',
  'Licht',
  'Nacht',
  'Tag',
  'Welt',
  'Land',
  'Meer',
  'Fluss',
  'Gras',
  'Blume',
  'Vogel',
  'Pferd',
  'Schaf',
  'Kuh',
  'Huhn',
  'Ente',
  'Frosch',
  'Nest',
  'Dach',
  'Turm',
  'Rad',
  'Zug',
  'Boot',
  'Schiff',
  'Helm',
  'Ring',
  'Topf',
  'Glas',
  'Korb',
  'Lampe',
  'Kerze',
  'Wolke',
  'Insel',
  'Brille',
  'Tasche',
  'Feder',
  'Nadel',
  'Perle',
  'Krone',
  'Flagge',
  'Harfe',
  'Leiter',
  'Anker',
  'Fackel',
  'Glocke',
  'Muschel',
  'Drache',
  'Rakete',
  'Kompass',
  'Kaktus',
  'Pilz',
  'Apfel',
  'Birne',
  'Pflaume',
  'Kirsche',
  'Banane',
  'Zitrone',
  'Melone',
  'Orange',
  'Tomate',
  'Kartoffel',
  'Zwiebel',
  'Paprika',
  'Bohne',
  'Erbse',
  'Nuss',
  'Keks',
  'Kakao',
  'Honig',
  'Zucker',
  'Salz',
  'Pfeffer',
  'Waffel',
  'Brezel',
  'Pudding',
  'Becher',
  'Teller',
  'Gabel',
  'Messer',
  'Spiegel',
  'Fenster',
  'Kissen',
  'Decke',
  'Teppich',
  'Ofen',
  'Uhr',
  'Sofa',
  'Schrank',
  'Kiste',
  'Dose',
  'Besen',
  'Seife',
  'Hafen',
  'Tunnel',
  'Wiese',
  'Acker',
  'Garten',
  'Hecke',
  'Quelle',
  'Pinguin',
  'Biber',
  'Igel',
  'Otter',
  'Fuchs',
  'Dachs',
  'Esel',
  'Zebra',
  'Panda',
  'Koala',
  'Robbe',
  'Wal',
  'Tiger',
  'Panther',
  'Falke',
  'Adler',
  'Eule',
  'Taube',
  'Rabe',
  'Pfote',
  'Klaue',
  'Schuppe',
  'Perlen',
  'Splitter',
  'Funke',
  'Flamme',
  'Glut',
  'Schatten',
  'Morgen',
  'Abend',
  'Sommer',
  'Herbst',
  'Winter',
  'Donner',
  'Blitz',
  'Nebel',
  'Tau',
  'Farbe',
  'Pinsel',
  'Stift',
  'Block',
  'Mappe',
  'Ordner',
  'Heft',
  'Seite',
  'Zeile',
  'Punkt',
  'Kreis',
  'Sternbild',
  'Domino',
  'Puzzle',
  'Murmel',
  'Knete',
];
